export const ROUTES = {
  INTRO: 'intro',
  LOGOS: 'logos',
  SIMU: 'simulation',
  PANO: 'panoramas',
  G1: 'quai-gustave-ador',
  G2: 'pont-de-bergues',
  LOGO: 'logo',
  INFOS: 'infos',
  SENT: 'sent'
}